<template>
  <div class="confirm-email">
    <div
      class="min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8"
    >
      <div class="max-w-md w-full space-y-8 bg-card rounded-xl border border-border shadow-sm p-8">
        <div>
          <h2 class="mt-6 text-center text-3xl font-extrabold text-foreground">
            {{ $t('auth.emailConfirmationTitle') }}
          </h2>
        </div>

        <div v-if="loading" class="flex justify-center">
          <svg
            class="animate-spin h-8 w-8 text-primary"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>

        <AlertBanner v-else-if="success" variant="success">
          <p class="text-sm">
            {{ $t('auth.emailHasBeenConfirmed') }}
            <router-link
              :to="localePath('Login')"
              class="font-medium text-primary hover:text-primary/80"
            >
              {{ $t('auth.signInNow') }}
            </router-link>
          </p>
        </AlertBanner>

        <AlertBanner v-else-if="error" variant="error">
          <p class="text-sm">{{ error }}</p>
          <p class="mt-2 text-sm text-muted-foreground">
            <router-link
              :to="localePath('Login')"
              class="font-medium text-primary hover:text-primary/80"
            >
              {{ $t('auth.goToLogin') }}
            </router-link>
          </p>
        </AlertBanner>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useLocalePath } from '../../composables/useLocalePath'
import apiClient from '../../api/client'
import AlertBanner from '../../components/AlertBanner.vue'

const route = useRoute()
const { t } = useI18n()
const { localePath } = useLocalePath()

const loading = ref(true)
const success = ref(false)
const error = ref(null)

onMounted(async () => {
  const token = route.query.confirmation_token

  if (!token) {
    error.value = t('auth.missingConfirmationToken')
    loading.value = false
    return
  }

  try {
    await apiClient.get('/auth/confirm', { params: { confirmation_token: token } })
    success.value = true
  } catch (error_) {
    const data = error_.response?.data
    error.value = t(
      data?.errors?.length ? 'auth.confirmationTokenInvalid' : 'auth.confirmationFailed',
    )
  } finally {
    loading.value = false
  }
})
</script>
